import Icon from '../../../components/AppIcon';

const QuickActionButton = ({ icon, label, onClick, variant = 'default' }) => {
  const variantClasses = {
    default: 'bg-primary text-primary-foreground hover:opacity-90',
    outline: 'bg-transparent border border-primary text-primary hover:bg-primary/10',
    secondary: 'bg-secondary text-secondary-foreground hover:opacity-90'
  };

  return (
    <button
      onClick={onClick}
      className={`flex flex-col md:flex-row items-center justify-center gap-1 md:gap-2 px-2 py-2 md:px-6 md:py-4 rounded-md font-medium text-xs md:text-base transition-smooth ${variantClasses?.[variant]}`}
    >
      <Icon name={icon} size={16} className="md:w-6 md:h-6" />
      <span className="hidden sm:inline text-[10px] md:text-base">{label}</span>
    </button>
  );
};

export default QuickActionButton;